<template>
  <div class="bg-white px-4 py-5 sm:p-6">
    <div class="flex flex-wrap justify-center sm:justify-between w-full gap-3 sm:gap-0 py-5 items-center">
      <div class="text-xl font-bold">Gestionar y Cargar Reservas
      </div>
      <button @click="$emit('updateValues', { 'view': 'listar' });"
        class="px-4 py-2 text-white bg-green-500 w-full mt-3 sm:mt-0 sm:w-auto rounded-md hover:bg-green-600 focus:outline-none ml-auto">
        <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor"
          class="inline-block w-6 h-6">
          <path stroke-linecap="round" stroke-linejoin="round" d="M9 15L3 9m0 0l6-6M3 9h12a6 6 0 010 12h-3" />
        </svg>
        <span class="ml-3">Volver</span>
      </button>
    </div>
    <slot></slot>
  </div>
  <div v-if="this.loadData.estado_cargue == 3" id="btnUpdateCargue" class="bg-white-50 px-4 py-3 text-left sm:px-6">
    <button type="button" @click="saveUpdateData()" v-text="view === 'crear' ? 'Guardar' : 'Consolidar Matriz'"
      class="w-full rounded-md sm:w-1/3 lg:w-1/6 border border-transparent bg-indigo-600 py-2 px-4 text-sm font-medium text-white shadow-sm hover:bg-indigo-700 focus:outline-none focus:ring-2 focus:ring-indigo-500 focus:ring-offset-2">
    </button>
  </div>
  <div>
  </div>
</template>

<script>
import { useAPIRest, swal, verifyHttpCode, generateTextError } from '@/common/constants';
/**
 Componente para crear o actualizar entidades.
 @vue-prop {string} view - Vista actual del componente, puede ser 'crear' o 'actualizar'.
 @vue-prop {string} entity - Entidad actual.
 @vue-prop {Function} customUpdateLoadData - Función para personalizar la actualización de los datos cargados.
 @vue-prop {Array} customSaveData - Métodos personalizados para guardar los datos.
 @vue-prop {string} primaryKey - Clave primaria de la entidad.
 @vue-prop {boolean} skipDefaultSave - Indica si se debe omitir el guardado por defecto.
 @vue-event {Function} updateValues - Evento para actualizar valores.
 */
export default {
  name: 'CreateUpdateReservasComponent',
  props: ['collectionReservas', 'collectionData', 'mainListCollectionData', 'view', 'paginate', 'options', 'selectedData', 'loadData', 'entity', 'authToken', 'listApi', 'queries', 'customListData', 'customUpdateLoadData', 'customSaveData', 'primaryKey', 'skipDefaultSave'],
  emits: ['updateValues'],
  async setup(props) {
    return {
      saveUpdateData: async () => {
        await swal.fire({
          title: 'Consolidar Reservas',
          icon: 'question',
          showCloseButton: true,
          showCancelButton: true,
          focusConfirm: false,
          cancelButtonText: 'Cancelar',
          confirmButtonText: 'Aceptar',
          customClass: {
            actions: 'm-0'
          },

          showLoaderOnConfirm: true,
          preConfirm: async () => {
            return await useAPIRest(process.env.VUE_APP_NEST_PASIVOEXIGIBLETEMP_UPDATECARGUE, 'POST', props.authToken, { 'id_cargue_siaff': props.selectedData.id }).then(async resJSON => resJSON);
          },

          allowOutsideClick: () => !swal.isLoading()
        }).then(async (result) => {
          if (result.isConfirmed && result.value !== true) {
            const resJSON = result.value;
            const { statusCode } = resJSON;
            delete resJSON['statusCode'];
            const textoError = generateTextError(resJSON);
            if (result.value.alertas.length > 0) {
              const errorAlertas = result.value.alertas.join('\n')
              await swal.fire({
                title: 'Consolidacion realizada con conflictos, se encontraron los siguientes errores',
                icon: 'error',
                focusConfirm: true,
                confirmButtonText: '¡Descargar informe de errores!'
              }).then(() => {
                const element = document.createElement('a');
                element.setAttribute('href', 'data:text/plain;charset=utf-8,' + encodeURIComponent(errorAlertas));
                element.setAttribute('download', 'informe_de_errores_consolidacion_matriz');
                element.style.display = 'none';
                document.body.appendChild(element);
                element.click();
                document.body.removeChild(element);
              });
            }
            if (result.value.rpsRepetidos.length > 0) {
              const erroresRp = result.value.rpsRepetidos.join('\n')
              await swal.fire({
                title: 'Consolidación realizada, se descartaron algunos RP repetidos',
                icon: 'error',
                focusConfirm: true,
                confirmButtonText: '¡Descargar informe de errores!'
              }).then(() => {
                const element = document.createElement('a');
                element.setAttribute('href', 'data:text/plain;charset=utf-8,' + encodeURIComponent(erroresRp));
                element.setAttribute('download', 'informe_de_errores_consolidacion_matriz');
                element.style.display = 'none';
                document.body.appendChild(element);
                element.click();
                document.body.removeChild(element);
              });
            }
            if (result.value.validaConsolidacion.length > 0 && result.value.alertas.length == 0) {
              await swal.fire({
                title: 'Novedad detectada',
                icon: 'success',
                focusConfirm: true,
                text: 'La Consolidación fue realizada totalmente.'
              })
            } 
            
            if (verifyHttpCode(statusCode, 'success') && result.value.alertas.length == 0 && result.value.rpsRepetidos.length == 0) {
              await swal.fire('Consolidación realizada con exito', '', 'success');

            } else {
              if (textoError.search('\n') !== 1)
                await swal.fire({
                  title: 'No se ha podido realizar la Actualización',
                  icon: 'error',
                  focusConfirm: true,
                  text: textoError,
                })
            }
          }
        });
        props.mainListCollectionData();
      }
    }
  },
}

</script>